import React, { useEffect, useState } from "react";
import axios from "axios";
import config from "../../config";
import { ToastContainer, toast, Bounce } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Select } from "antd";

axios.defaults.withCredentials = true;

const EditVideo = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showDownloadable, setShowDownloadable] = useState(false);
    // We assume there's always a valid video object in location.state
    const existingVideo = location.state?.video;
    if (!existingVideo?.id) {
        toast.error("فایل نامعتبر است!");
        navigate("/dashboar/videos");
    }
    const type = location.state?.type;

    const [formData, setFormData] = useState({
        id: "",
        name: "",
        title: "",
        imageURL: "",
        duration: 0,
        uniqueId: "",
        teacher: "",
        size: "",
        downloadable: false,
        pdfTarget: 0,
        createdDate: new Date(),
    });

    // For file selection
    const [selectedImage, setSelectedImage] = useState(null);

    const [loading, setLoading] = useState(false);

    // ------------------ Fetch the latest video info on mount ------------------ //
    useEffect(() => {
        if (!existingVideo?.id) return;

        if (type === 1) {
            setShowDownloadable(true);
        }
        fetchVideoDetails(existingVideo.id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


const handleDateChange = (date) => {
    if (!date) return;

    // تبدیل آبجکت شمسی به Date میلادی
    const fullDate = date.toDate(); // به صورت 1 Jan سال انتخاب‌شده 00:00:00

    setFormData((prev) => ({
        ...prev,
        createdDate: fullDate,
    }));
};




    const fetchVideoDetails = async (videoId) => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${config.apiBaseUrl}/api/Video/GetVideoById?id=${videoId}`,
                {
                    headers: {
                        HeaderKey: config.HeaderKey,
                    },
                    withCredentials: true,
                }
            );
            if (response.data) {
                const vid = response.data;
                const parsedDate = new Date(vid.createdDate);
                const isValid = parsedDate instanceof Date && !isNaN(parsedDate);
                const isReasonable = isValid && parsedDate.getFullYear() >= 2000;
                if (vid.fileType === 1) {
                    setShowDownloadable(true);
                }
                setFormData({
                    id: vid.id,
                    name: vid.name || "",
                    title: vid.title || "",
                    imageURL: vid.imageURL || "",
                    duration: vid.duration || 0,
                    uniqueId: vid.uniqueId || "",
                    teacher: vid.teacher || "",
                    size: vid.size || 0,
                    downloadable: vid.downloadable || false,
                    pdfTarget: vid.pdfTarget ?? 0,
                    createdDate: isReasonable ? parsedDate : new Date()

                });
            }

        } catch (err) {

            toast.error("خطا در دریافت اطلاعات !", { autoClose: 3000 });
            if (err.response && err.response.status === 401) {
                navigate("/");
            }
        } finally {
            setLoading(false);
        }
    };

    // ------------------ Handle input changes for editable fields ------------------ //
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handlePdfTargetChange = (value) => {
        setFormData((prev) => ({
            ...prev,
            pdfTarget: value,
        }));
    };

    // ------------------ Handle image selection ------------------ //
    const handleImageChange = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedImage(e.target.files[0]);
        }
    };

    // ------------------ Update Video (multipart/form-data) ------------------ //
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.teacher) {
            toast.error(<p dir="rtl" className="font-custom">لطفا نام مدرس را وارد کنید</p>, { autoClose: 3000 });
            return;
        }
        if (!formData.id) {
            toast.error("شناسه نامعتبر است!", { autoClose: 3000 });
            return;
        }
        if (!formData.title) {
            toast.error(<p dir="rtl" className="font-custom">لطفا عنوان را وارد کنید</p>, { autoClose: 3000 });
            return;
        }

        try {
            setLoading(true);

            // Prepare a FormData object
            const formDataToSend = new FormData();

            formDataToSend.append("id", formData.id);
            formDataToSend.append("name", formData.name);
            formDataToSend.append("title", formData.title);
            formDataToSend.append("duration", formData.duration);
            formDataToSend.append("uniqueId", formData.uniqueId);
            // If an image was selected, append the file
            if (selectedImage) {
                formDataToSend.append("image", selectedImage);
                formDataToSend.append("pictureUrl", formData.imageURL || "");
            } else {
                formDataToSend.append("pictureUrl", formData.imageURL || "");
            }
            formDataToSend.append("teacher", formData.teacher);
            formDataToSend.append("createdDate", formData.createdDate.toISOString());
            formDataToSend.append("downloadable", formData.downloadable);
            formDataToSend.append("pdfTarget", formData.pdfTarget);
            // Now send via POST to your UpdateVideo endpoint
            const response = await axios.post(
                `${config.apiBaseUrl}/api/Video/UpdateVideo`,
                formDataToSend,
                {
                    headers: {
                        // Let the browser set the Content-Type with boundary for FormData
                        HeaderKey: config.HeaderKey,
                    },
                    withCredentials: true,
                }
            );

            if (response.status === 200) {
                toast.success(<p dir="rtl" className="font-custom">با موفقیت به‌روزرسانی شد</p>);
                setTimeout(() => {
                    if (type === 0) {
                        navigate("/dashboard/videos");
                    }else if (type === 1) {
                        navigate("/dashboard/pdfs");
                    }else {
                        navigate("/dashboard/voices");

                    }
                }, 300);
            } else {
                toast.error("خطا در ویرایش !", { autoClose: 3000 });
            }
        } catch (error) {
            if (error.response && error.response.status === 409) {
                toast.error("شناسه یکتای وارد شده تکراری است!", { autoClose: 3000 });
            } else {
                toast.error("خطا در برقراری ارتباط با سرور!", { autoClose: 3000 });
                if (error.response && error.response.status === 401) {
                    navigate("/");
                }
            }

        } finally {
            setLoading(true);
            setIsLoading(false);
        }
    };

    // ------------------ Display Loading State ------------------ //
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center rtl font-custom">
                <p>...در حال بروزرسانی</p>
                <div className="block ml-2">
                    <FaSpinner className="animate-spin" />

                </div>
            </div>
        );
    }

    // ------------------ Render Form ------------------ //
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50 p-6 rtl font-custom">
            <div className="w-full max-w-lg bg-white p-8 rounded-lg shadow-md">
                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Name (read-only) */}
                    <div>
                        <label className="block mb-1 text-right font-semibold text-gray-700">
                            : نام فایل
                        </label>
                        <input
                            type="text"
                            name="name"
                            className="w-full p-3 border rounded-md bg-gray-100 cursor-not-allowed"
                            value={formData.name}
                            readOnly
                        />
                    </div>

                    {/* Duration (read-only) */}
                    <div className="flex gap-2">
                        <div className="flex flex-col w-1/2 text-right">
                            <label className="block text-right mb-1 font-semibold text-gray-700">
                                : سایز (بایت)
                            </label>
                            <input
                                type="number"
                                name="size"
                                className="w-full p-3 border rounded-md bg-gray-100 cursor-not-allowed"
                                value={formData.size}
                                readOnly
                            />
                        </div>
                        <div className="flex flex-col w-1/2 text-right">
                            <label className="block text-right mb-1 font-semibold text-gray-700">
                                : مدت (ثانیه)
                            </label>
                            <input
                                type="number"
                                name="duration"
                                className="w-full p-3 border rounded-md bg-gray-100 cursor-not-allowed"
                                value={formData.duration}
                                readOnly
                            />
                        </div>
                    </div>


                    {/* Title (required, editable) */}
                    <div>
                        <label className="block text-right mb-1 font-semibold text-gray-700">
                            : عنوان
                        </label>
                        <input
                            type="text"
                            name="title"
                            className="w-full p-3 border rounded-md"
                            value={formData.title}
                            dir="rtl"
                            onChange={handleChange}
                        />
                    </div>
                    <div>
                        <label className="block text-right mb-1 font-semibold text-gray-700">
                            : شناسه یکتا
                        </label>
                        <input
                            type="text"
                            name="uniqueId"
                            className="w-full p-3 border rounded-md"
                            value={formData.uniqueId}
                            dir="rtl"
                            onChange={handleChange}
                        />
                    </div>
                    {/* Teacher Input */}
                    <div>
                        <label className="block text-right mb-1 font-semibold text-gray-700">
                            : مدرس
                        </label>
                        <input
                            type="text"
                            name="teacher"
                            className="w-full p-3 border rounded-md"
                            value={formData.teacher}
                            dir="rtl"
                            onChange={handleChange}
                        />
                    </div>

                    {/* Created Date Input */}
                    <div>
                        <label className="block text-right mb-1 font-semibold text-gray-700">
                            : تاریخ تدریس
                        </label>
                        <div className="w-full p-3 border rounded-md">
                            <DatePicker
                                calendar={persian}
                                locale={persian_fa}
                                value={formData.createdDate}
                                onChange={handleDateChange}
                                calendarPosition="bottom-right"
                                onlyYearPicker // فقط نمایش سال
                            />
                        </div>
                    </div>
                    {showDownloadable ? <div className="space-y-4">
                        <div>
                            <label className="block text-right mb-1 font-semibold text-gray-700">
                                : پلتفرم مقصد
                            </label>
                            <Select
                                value={formData.pdfTarget}
                                onChange={handlePdfTargetChange}
                                className="w-full text-right font-custom"
                                placeholder="پلتفرم مقصد"
                                options={[
                                    { value: 0, className: "font-custom text-right", label: "هر دو" },
                                    { value: 1, className: "font-custom text-right", label: "دسکتاپ" },
                                    { value: 2, className: "font-custom text-right", label: "اندروید" },
                                ]}
                            />
                        </div>
                        <div className="flex items-center justify-end mb-2 gap-2">
                            <label className="relative inline-flex items-center cursor-pointer">
                                <input
                                    type="checkbox"
                                    name="downloadable"
                                    checked={formData.downloadable}
                                    onChange={handleChange}
                                    className="sr-only peer"
                                />
                                <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-2 peer-focus:ring-green-500 peer-checked:bg-green-600 transition-colors peer-checked:after:translate-x-full after:content-[''] after:absolute after:left-1 after:top-1 after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
                            </label>
                            <label className="text-gray-700">قابلیت دانلود</label>
                        </div>
                    </div> : ""}
                    
                    {/* ImageURL (editable text) */}
                    <div>
                        <label className="block text-right mb-1 font-semibold text-gray-700">
                            انتخاب تصویر کاور (اختیاری)
                        </label>
                        <input
                            type="file"
                            accept="image/*"
                            onChange={handleImageChange}
                            className="p-2 border rounded-md"
                        />
                        {selectedImage ? (
                            <p className="mt-1 text-sm text-green-600">
                                تصویر انتخاب شده: {selectedImage.name}
                            </p>
                        ) : formData.imageURL ? (
                            <p className="mt-1 text-sm text-gray-600">
                                تصویر فعلی: {formData.imageURL}
                            </p>
                        ) : null}
                    </div>

                    {/* Submit Button */}

                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full flex justify-center items-center gap-2 bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg text-sm px-4 py-2.5 transition-colors duration-300 disabled:opacity-70"
                    >
                        {isLoading ? <FaSpinner className="animate-spin" /> : "ویرایش"}
                    </button>
                </form>
            </div>

            <ToastContainer
                position="bottom-center"
                autoClose={5000}
                hideProgressBar={false}
                theme="dark"
                transition={Bounce}
                className={"rtl font-custom text-right"}
            />
        </div>
    );
};

export default EditVideo;
